/**
 * Landing Page — Comparatif GPS chien
 * Fetches competitor prices and renders counters, bar chart, and comparison table.
 */
(function () {
  'use strict';

  var container = document.getElementById('landing-price-comparison');
  if (!container) return;

  var shop = container.dataset.shop;
  var jaggerStaticPrice = parseFloat(container.dataset.jaggerPrice) || 169;
  var productUrl = container.dataset.productUrl || '/products/jag-gps-s2';
  var API_BASE = '/apps/jl-prices';
  var COMPETITOR_ORDER = ['tractive', 'weenect', 'invoxia', 'kippy'];

  // ── Helpers ──────────────────────────────────────────────────

  function formatPrice(price) {
    if (price == null) return '\u2014';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('fr-FR', {
      day: 'numeric', month: 'long', year: 'numeric'
    });
  }

  function getMonthlyRate(competitor) {
    var subs = competitor.subscriptions;
    if (!subs) return null;
    var keys = Object.keys(subs);
    if (keys.length === 0) return null;
    var maxMonthly = 0;
    keys.forEach(function (k) {
      if (subs[k].monthlyPrice != null && subs[k].monthlyPrice > maxMonthly) {
        maxMonthly = subs[k].monthlyPrice;
      }
    });
    return maxMonthly === 0 ? null : maxMonthly;
  }

  function buildEntries(data) {
    var jaggerPrice = jaggerStaticPrice || data.jaggerPrice || 169;
    var jagger = {
      slug: 'jagger', name: 'Jagger Lewis', logoUrl: null,
      productPrice: jaggerPrice, after18Months: jaggerPrice, after5Years: jaggerPrice,
      annualCost: 0, isJagger: true
    };

    var sorted = COMPETITOR_ORDER.map(function (slug) {
      var c = data.competitors.find(function (comp) { return comp.slug === slug; });
      if (!c) return null;
      // On utilise les totaux DÉJÀ calculés par l'API (after18Months, after5Years),
      // qui gèrent le barème en escalier d'Invoxia (348,90 € à 18 mois, 738,60 € à 5 ans)
      // et restent identiques pour les autres concurrents. Plus de recalcul depuis un
      // tarif mensuel (qui captait à tort un forfait sans-engagement obsolète).
      // Coût annuel récurrent = surcoût de la 2e année (after2Years − after1Year).
      if (c.after2Years != null && c.after1Year != null) {
        c.annualCost = Math.round(c.after2Years - c.after1Year);
      } else {
        var monthly = getMonthlyRate(c);
        c.annualCost = monthly != null ? Math.round(monthly * 12) : 0;
      }
      return c;
    }).filter(Boolean);

    return [jagger].concat(sorted);
  }

  // ── Counter animation ────────────────────────────────────────

  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(start + (target - start) * ease);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(entries) {
    var jaggerPrice = entries[0].after5Years;
    var counterEls = container.querySelectorAll('[data-counter-slug]');

    counterEls.forEach(function (el) {
      var slug = el.dataset.counterSlug;
      var entry = entries.find(function (e) { return e.slug === slug; });
      if (!entry || !entry.after5Years) return;
      var diff = Math.round(entry.after5Years - jaggerPrice);
      if (diff <= 0) return;

      var valueEl = el.querySelector('.landing-pc__counter-num');
      if (!valueEl) return;

      var observer = new IntersectionObserver(function (items) {
        items.forEach(function (item) {
          if (item.isIntersecting) {
            animateCounter(valueEl, diff, 1800);
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(el);
    });
  }

  // ── Bar chart ────────────────────────────────────────────────

  function renderBarChart(entries) {
    var barsEl = container.querySelector('.landing-pc__bars');
    if (!barsEl) return;

    var maxPrice = 0;
    entries.forEach(function (e) {
      if (e.after5Years && e.after5Years > maxPrice) maxPrice = e.after5Years;
    });
    if (maxPrice === 0) return;

    var html = entries.map(function (e) {
      var pct = Math.round((e.after5Years / maxPrice) * 100);
      var cls = e.isJagger ? 'landing-pc__bar-fill--jagger' : 'landing-pc__bar-fill--competitor';
      var labelContent = e.isJagger
        ? '<a href="' + productUrl + '" style="color:inherit;text-decoration:none;">' + e.name + '</a>'
        : e.name;
      return '<div class="landing-pc__bar-row">' +
        '<div class="landing-pc__bar-label">' + labelContent + '</div>' +
        '<div class="landing-pc__bar-track">' +
          '<div class="landing-pc__bar-fill ' + cls + '" data-width="' + pct + '%">' +
            '<span>' + formatPrice(e.after5Years) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    barsEl.innerHTML = html;

    // Animate bars on scroll
    var observer = new IntersectionObserver(function (items) {
      items.forEach(function (item) {
        if (item.isIntersecting) {
          var fills = barsEl.querySelectorAll('.landing-pc__bar-fill');
          fills.forEach(function (fill, i) {
            setTimeout(function () {
              fill.style.width = fill.dataset.width;
            }, i * 150);
          });
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });
    observer.observe(barsEl);
  }

  // ── Comparison table ─────────────────────────────────────────

  function renderTable(data) {
    var tableWrap = container.querySelector('.landing-pc__table-wrap');
    if (!tableWrap) return;

    var entries = buildEntries(data);
    var jaggerPrice = entries[0].after5Years;
    var highlightBg = '#E2FBE8';
    var highlightText = '#2B6536';

    function jaggerStyle() {
      return 'background-color:' + highlightBg + ';color:' + highlightText + ';font-weight:700;';
    }

    function formatDiff(diff) {
      if (diff == null || diff <= 0) return '';
      return '+' + formatPrice(diff);
    }

    var headerCells = entries.map(function (e) {
      var isJ = e.isJagger;
      var style = isJ ? jaggerStyle() : '';
      var logo = e.logoUrl
        ? '<img src="' + e.logoUrl + '" alt="' + e.name + '" class="price-comparison-table__logo">'
        : '';
      var cls = 'price-comparison-table__th' + (isJ ? ' price-comparison-table__th--jagger' : '');
      var nameHtml = isJ
        ? '<a href="' + productUrl + '" style="color:inherit;text-decoration:none;">' + e.name + '</a>'
        : e.name;
      return '<th class="' + cls + '" style="' + style + '">' + logo + '<span>' + nameHtml + '</span></th>';
    }).join('');

    function priceRow(label, field) {
      return entries.map(function (e) {
        var isJ = e.isJagger;
        var style = isJ ? jaggerStyle() : '';
        var cls = 'price-comparison-table__td' + (isJ ? ' price-comparison-table__td--jagger' : '');
        if (isJ) {
          return '<td class="' + cls + '" style="' + style + '">' + formatPrice(e[field]) +
            '<br><span class="price-comparison-table__yes">\u2713</span></td>';
        }
        var diff = (e[field] && jaggerPrice) ? e[field] - jaggerPrice : null;
        var diffHtml = (diff && diff > 0)
          ? '<span class="price-comparison-table__diff">' + formatDiff(diff) + '</span>' : '';
        return '<td class="' + cls + '">' + formatPrice(e[field]) + diffHtml + '</td>';
      }).join('');
    }

    var FRENCH_SLUGS = ['jagger', 'weenect', 'invoxia'];
    var frenchCells = entries.map(function (e) {
      var isJ = e.isJagger;
      var isFrench = isJ || FRENCH_SLUGS.indexOf(e.slug) !== -1;
      var style = isJ ? jaggerStyle() : '';
      var cls = 'price-comparison-table__td' + (isJ ? ' price-comparison-table__td--jagger' : '');
      if (isFrench) return '<td class="' + cls + '" style="' + style + '"><span class="price-comparison-table__yes">\u2713</span></td>';
      return '<td class="' + cls + '"><span class="price-comparison-table__no">\u2717</span></td>';
    }).join('');

    var noCommitCells = entries.map(function (e) {
      var isJ = e.isJagger;
      var style = isJ ? jaggerStyle() : '';
      var cls = 'price-comparison-table__td' + (isJ ? ' price-comparison-table__td--jagger' : '');
      return '<td class="' + cls + '" style="' + style + '"><span class="price-comparison-table__yes">\u2713</span></td>';
    }).join('');

    var annualCells = entries.map(function (e) {
      var isJ = e.isJagger;
      var style = isJ ? jaggerStyle() : '';
      var cls = 'price-comparison-table__td' + (isJ ? ' price-comparison-table__td--jagger' : '');
      if (isJ) return '<td class="' + cls + '" style="' + style + '">' + formatPrice(0) +
        '<br><span class="price-comparison-table__yes">\u2713</span></td>';
      return '<td class="' + cls + '"><span class="price-comparison-table__diff" style="display:inline;font-size:inherit;">' +
        formatPrice(e.annualCost) + '</span></td>';
    }).join('');

    tableWrap.innerHTML =
      '<div class="price-comparison-table__wrapper">' +
        '<table class="price-comparison-table__table">' +
          '<thead><tr><th class="price-comparison-table__th price-comparison-table__th--label"></th>' + headerCells + '</tr></thead>' +
          '<tbody>' +
            '<tr><td class="price-comparison-table__td price-comparison-table__td--label">Co\u00fbt \u00e0 5 ans</td>' + priceRow('5y', 'after5Years') + '</tr>' +
            '<tr><td class="price-comparison-table__td price-comparison-table__td--label">Co\u00fbt \u00e0 18 mois</td>' + priceRow('18m', 'after18Months') + '</tr>' +
            '<tr><td class="price-comparison-table__td price-comparison-table__td--label">Disponible sans engagement</td>' + noCommitCells + '</tr>' +
            '<tr><td class="price-comparison-table__td price-comparison-table__td--label">D\u00e9velopp\u00e9 en France</td>' + frenchCells + '</tr>' +
            '<tr><td class="price-comparison-table__td price-comparison-table__td--label">Co\u00fbt annuel</td>' + annualCells + '</tr>' +
          '</tbody>' +
        '</table>' +
      '</div>' +
      '<p class="price-comparison-table__footnote" style="text-align:center;margin-top:1.5rem;">' +
        'M\u00e9thodologie\u00a0: co\u00fbt calcul\u00e9 \u00e0 partir du prix du traceur et, pour les mod\u00e8les avec abonnement, de la formule mensuelle affich\u00e9e sur les sites officiels' +
        (data.lastUpdated ? ' au ' + formatDate(data.lastUpdated) : '') +
        '. Certaines marques proposent aussi des formules annuelles ou pluriannuelles, non retenues dans ce sc\u00e9nario.' +
        '<br>Les noms de produits mentionn\u00e9s appartiennent \u00e0 leurs fabricants respectifs.' +
      '</p>';
  }

  // ── Init ─────────────────────────────────────────────────────

  async function init() {
    try {
      var res = await fetch(API_BASE + '/api/prices?shop=' + encodeURIComponent(shop));
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var data = await res.json();

      var entries = buildEntries(data);

      initCounters(entries);
      renderBarChart(entries);
      renderTable(data);

      // Update legal dates
      if (data.lastUpdated) {
        var formatted = formatDate(data.lastUpdated);
        document.querySelectorAll('.landing-pc__legal-date, .landing-pc__legal-date-chart').forEach(function (el) {
          el.textContent = formatted;
        });
      }
    } catch (err) {
      console.error('[Landing PC] Error:', err.message);
    }
  }

  // ── Sticky cart — scroll show/hide ───────────────────────────

  function initStickyCart() {
    var wrapper = document.getElementById('lp-sticky-wrapper');
    if (!wrapper) return;

    var hero = container.querySelector('.landing-pc__hero');
    var threshold = hero ? (hero.offsetTop + hero.offsetHeight * 0.5) : 400;

    function onScroll() {
      var show = window.scrollY > threshold;

      if (show) {
        var cta = container.querySelector('.landing-pc__cta-section');
        if (cta) {
          var ctaTop = cta.getBoundingClientRect().top;
          if (ctaTop < window.innerHeight) {
            show = false;
          }
        }
      }

      if (show) {
        wrapper.classList.add('lp-sticky-visible');
      } else {
        wrapper.classList.remove('lp-sticky-visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Fix default variant — Liquid renders the first admin-sorted variant
    // (Avec Smartdock 209€) but we want the cheapest (Sans Smartdock 169€)
    var xoProd = wrapper.querySelector('xo-product');
    if (xoProd) {
      var pUrl = xoProd.getAttribute('xo-product-url');
      var sId = xoProd.getAttribute('xo-section-id');
      var vId = xoProd.getAttribute('xo-selected-or-first-available-variant-id');
      if (pUrl && sId && vId) {
        fetch(pUrl + '?section_id=' + sId + '&variant=' + vId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var els = xoProd.querySelectorAll('xo-product-will-change[xo-unique-id]');
            els.forEach(function (el) {
              var uid = el.getAttribute('xo-unique-id');
              var newEl = doc.querySelector('xo-product-will-change[xo-unique-id="' + uid + '"]');
              if (newEl) el.innerHTML = newEl.innerHTML;
            });
          })
          .catch(function () {});
      }
    }
  }

  initStickyCart();
  init();
})();
